module.exports = __webpack_public_path__ + "img/asset-reports.5a3e72bc.webp";